import { Stethoscope, Zap, Sparkles } from "lucide-react";

// helper para slugs
const createSlug = (text) =>
  text
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^\w\s-]/g, "")
    .trim()
    .replace(/\s+/g, "-");

    export const serviceCategories = [
    // ==========================
    // 🩺 MEDICINA ALTERNATIVA
    // ==========================
  {
    title: "Medicina alternativa",
    description:
      "Terapias naturales que fortalecen, equilibran y sanan tu cuerpo desde la raíz.",
    icon: Stethoscope,
    buttonText: "Explorar tratamientos",
    services: [
     
      {
      name: "Consulta médica personalizada",
      description: `
          Realizamos una valoración médica personalizada que nos permite conocerte,
          identificar la causa real de tus síntomas y diseñar un plan integral acorde a tus necesidades.
      `,
      video: "https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092693/video4_l6lj6x.mp4"
      },


      {
        name: "Hidrocolonterapia alemana con ozono",
        description: `
          Elimina toxinas, mejora la digestión y fortalece tu sistema inmunológico a través de una limpieza profunda y segura del colon.
          <br/><br/>
          <h3 class='text-green-600 font-semibold text-2xl mb-2 text-center'>Beneficios</h3>
          Desintoxicación, alivio del estreñimiento, colón irritable, sensación de ligereza, hemorroides, divertículos, pólipos.
          <br/><br/>
          <p class='text-green-700 font-semibold text-center text-xl mt-6'>
          👉 Agenda tu sesión de limpieza interna y siente el cambio desde el primer día.
        `,
        video: "https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092943/video5_qfhckk.mp4"
      },

      {
      name: "Sueroterapia ortomolecular y homeopática",
      description: `
        Infusión intravenosa personalizada con vitaminas, minerales, oligoelementos, antioxidantes y aminoácidos que revitalizan el cuerpo desde el interior.
        <br/><br/>
        <h3 class='text-green-600 font-semibold text-2xl mb-2 text-center'>Beneficios</h3>
        Fortalece el sistema inmune, aumenta energía y rendimiento físico, favorece la regeneración celular y el equilibrio metabólico.
        <br/><br/>
        <h3 class='text-green-600 font-semibold text-2xl mb-2 text-center'>Algunos de nuestros sueros son:</h3>
        Mega dosis de vitamina C, détox, azul de metileno, revitalizante, dolor e inflamación, gastritis, metabólico, insomnio, complejo B, inmunologico, fatiga y muchos más.
        <br/><br/> 
        <p class='text-green-700 font-semibold text-center text-xl mt-6'>
          👉 Dale a tu cuerpo lo que necesita… Contamos con una amplia variedad de sueroterapia según tu necesidad.
        </p>
      `,

      // 🎥 Como tu sistema los espera: video1, video2, video3 ...
      video15: "https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092728/video15_cvbgsm.mp4",
      video16: "https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092939/video16_qoyo9l.mp4",
      video17: "https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092901/video17_xdbwuk.mp4"
    },

    {
      name: "Nebulización homeopática",
      description: `
        <p class='text-gray-600 text-lg text-center mb-4'>
        La nebulización homeopática es un tratamiento natural que utiliza microdosis de medicamentos homeopáticos
        en forma de vapor para mejorar la función respiratoria, fortalecer el sistema inmune
        y aliviar síntomas asociados a afecciones pulmonares o alérgicas.
        </p>

        <h3 class='text-green-600 font-semibold text-2xl mb-2 text-center'>
        Beneficios
        </h3>

        <div class='flex justify-center'>
        <ul class='list-disc text-gray-600 text-lg leading-relaxed space-y-2 text-left'>
        <li>Mejora la oxigenación y la función pulmonar.</li>
        <li>Reduce la congestión nasal y la tos.</li>
        <li>Fortalece el sistema respiratorio y defensas naturales.</li>
        <li>Favorece una respiración más libre y profunda.</li>
        <li>Alivia molestias causadas por alergias y contaminación ambiental.</li>
        </ul>
        </div>

        <p class='text-green-700 font-semibold text-center text-xl mt-6'>
        👉 Respira mejor y siente el alivio de una terapia natural sin efectos secundarios.
        </p>
        `,
  
        //  🎥 Aquí tu video directo desde Cloudinary
         video19: "https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092742/video19_kdocaf.mp4",
    },

     {
        name: "Plasma articular",
        description: `
          Tratamiento biológico que utiliza tu propio plasma rico en factores de crecimiento para reparar tejidos, aliviar el dolor y regenerar articulaciones.
          <br/><br/>
          <h3 class='text-green-600 font-semibold text-2xl mb-2 text-center'>Beneficios</h3>
          Disminuye el dolor y la inflamación articular, estimula la regeneración de cartílago y tejido conectivo, alternativa natural para el manejo de lesiones o desgaste articular.
          <br/><br/>
          <p class='text-green-700 font-semibold text-center text-xl mt-6'>
            👉 Devuélvele movimiento y vitalidad a tus articulaciones.
          </p>
        `,
        // 🎥 Solo este servicio tiene videos
        video6:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092892/video6_d07gpx.mp4",
        video7:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092693/video7_dbrrfp.mp4",
        video8:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092697/video8_ennzhs.mp4"
      },

      {
        name: "Ozonoterapia",
        description: `
          Uso médico del ozono como agente regenerador, antioxidante, antimicótico y antiinflamatorio. 
          Se aplica por diferentes vías según la necesidad terapéutica.
          <br/><br/>
          <h3 class='text-green-600 font-semibold text-2xl mb-2 text-center'>Beneficios</h3>
          Mejora la oxigenación celular, fortalece el sistema inmune, 
          apoya procesos de desintoxicación y rejuvenecimiento.
          <br/><br/>
          <p class='text-green-700 font-semibold text-center text-xl mt-6'>
            👉 Purifica, revitaliza y fortalece tu salud de forma natural.
          </p>
        `,
        // 🎥 Solo este servicio tiene videos
        video1:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092689/video1_h8eoqp.mp4",
        video2:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092894/video2_gtaynk.mp4",
        video3:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092698/video3_p2tued.mp4"
      },

     {
        name: "Acupuntura",
        description: `
          Milenario método de la medicina tradicional china que restablece el flujo energético del cuerpo mediante la estimulación de puntos específicos.
          <br/><br/>
          <h3 class='text-green-600 font-semibold text-2xl mb-2 text-center'>Beneficios</h3>
          Equilibra cuerpo y mente, alivia dolor, estrés y trastornos emocionales, favorece el bienestar integral y la armonía energética.
          <br/><br/>
          <p class='text-green-700 font-semibold text-center text-xl mt-6'>
            👉 Equilibra tu energía y renueva tu vitalidad.
          </p>
        `,
        // 🎥 Solo este servicio tiene videos
         image4:"https://res.cloudinary.com/dmgtsa6kx/image/upload/v1763092675/imag4_apfrjb.jpg",
         image5:"https://res.cloudinary.com/dmgtsa6kx/image/upload/v1763266345/imag5_r56rda.jpg"
          
      },
      
      {
        name: "Terapia neural",
        description: `
          Técnica reguladora del sistema nervioso que actúa sobre bloqueos energéticos y cicatrices interferentes, restableciendo la comunicación natural del cuerpo.
          <br/><br/>
          <h3 class='text-green-600 font-semibold text-2xl mb-2 text-center'>Beneficios</h3>
          Alivio del dolor crónico y tensiones, equilibrio del sistema nervioso, mejora del bienestar emocional y energético
          <br/><br/>
          <p class='text-green-700 font-semibold text-center text-xl mt-6'>
            👉 Alivia el dolor y recupera tu armonía interior.
          </p>
        `,
        // 🎥 Solo este servicio tiene videos
        video9:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092898/video9_apxm9o.mp4",
        video10:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092717/video10_chf459.mp4"
    
      },



      {
        name: "Terapia con cannabis medicinal",
        description: `
          Tratamiento natural basado en los principios activos del cannabis para el control del dolor, el sueño y el equilibrio emocional.
          <br/><br/>
          <h3 class='text-green-600 font-semibold text-2xl mb-2 text-center'>Beneficios</h3>
           Alivia dolor crónico y ansiedad, regula el sueño y mejora el estado de ánimo. Terapia segura, natural y personalizada.
          <br/><br/>
          <p class='text-green-700 font-semibold text-center text-xl mt-6'>
            👉 Descubre los beneficios del cannabis medicinal con acompañamiento profesional.
          </p>
        `,
        // 🎥 Solo este servicio tiene videos
        video11:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092718/video11_i59f7o.mp4"
      },
      {
        name: "Regeneración celular",
        description: `
        <h3 class='text-green-600 font-semibold text-2xl mb-2 text-center'> Tratamiento Anti Edad – Renew Cell</h3>
          Terapia bio-regeneradora que utiliza factores de crecimiento y activos celulares para revitalizar el cuerpo, prevenir enfermedades degenerativas como el alzheimer, parkinson, cáncer y artrosis.
          <br/><br/>
          <h3 class='text-green-600 font-semibold text-2xl mb-2 text-center'>Beneficios</h3>
          Retarda el envejecimiento celular, estimula la regeneración natural del organismo, mejora la vitalidad, luminosidad y tono de la piel.
          <br/><br/>
          <p class='text-green-700 font-semibold text-center text-xl mt-6'>
           👉 Renueva tus células y revitaliza tu cuerpo
          </p>
        `,
        // 🎥 Solo este servicio tiene videos
        video20:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092748/video20_lniauj.mp4"       
      },
      {
        name: "Tratamiento capilar para la alopecia",
        description: `
          Procedimiento regenerativo que estimula los folículos capilares, fortalece el cabello y promueve su crecimiento natural.
          <br/><br/>
          <h3 class='text-green-600 font-semibold text-2xl mb-2 text-center'>Beneficios</h3>
          Disminuye la caída del cabello, mejora la densidad y vitalidad capilar, restaura la salud del cuero cabelludo.
          <br/><br/>
          <p class='text-green-700 font-semibold text-center text-xl mt-6'>
            👉 Recupera tu confianza y tu cabello de forma natural.

          </p>
        `,
        // 🎥 Solo este servicio tiene videos
        video12:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092726/video12_e3wjxm.mp4",
        video13:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092729/video13_ekjkmn.mp4",
        video14:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092725/video14_r1jhjh.mp4"
               
      },
      {
      name: "Manejo del insomnio, estrés, ansiedad y depresión",
      description: `
        <h3 class='text-green-600 font-semibold text-2xl mb-2 text-center'>
           Sincronizador de Ondas Cerebrales
        </h3>

        <p class='text-gray-600 text-lg text-center mb-4'>
          Tecnología de neuroestimulación que regula la frecuencia cerebral para inducir estados de relajación,
          concentración y descanso.
        </p>

        <h3 class='text-green-600 font-semibold text-2xl mb-2 text-center'>
          Beneficios
        </h3>

        <p class='text-gray-600 text-lg text-center mb-4'>
          Reduce el estrés y la ansiedad, aumenta la concentración y la claridad mental,
          mejora la calidad del sueño y el bienestar emocional.
        </p>

        <p class='text-green-700 font-semibold text-center text-xl mt-6'>
          👉 Recupera tu paz interior y tu bienestar emocional.
        </p>
      `,
      video18:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092737/video18_c6jmbs.mp4"
     },

     
      
     {
      name: "Pruebas rápidas en sangre",
      description: `
   

     <p class='text-gray-700 text-lg text-center mb-4'>
      Evaluamos tus indicadores básicos de salud mediante pruebas rápidas y confiables:
      </p>

      <div class='flex justify-center'>
      <ul class='list-disc text-gray-700 text-lg leading-relaxed space-y-2 text-left'>
        <li>Examen bioquímico de orina</li>
        <li>Glucometría</li>
        <li>Helicobacter pylori</li>
        <li>Hepatitis A</li>
        <li>Antígeno carcinoembrionario</li>
        <li>Antígeno prostático semicuantitativo</li>
      </ul>
    </div>

    <p class='text-green-700 font-semibold text-center text-xl mt-6'>
      👉 Conoce el estado de tu salud en minutos y recibe orientación médica inmediata.
    </p>
    `,
    image3:"https://res.cloudinary.com/dmgtsa6kx/image/upload/v1763092675/imag3_vhnlzk.jpg" 
  },


    ].map((srv) => ({
      ...srv,
      url: `/servicios/${createSlug(srv.name)}`,
    })),
  },

  // ==========================
  // 💆‍♀️ ESTÉTICA FACIAL
  // ==========================
  {
    title: "Estética facial",
    description:
      "Redescubre tu luminosidad con terapias personalizadas, seguras y efectivas.",
    icon: Zap,
    buttonText: "Ver tratamientos faciales",
    services: [
      {
        name: "Limpieza facial profunda",
        description: `
          El primer paso hacia una piel sana. Elimina impurezas, células muertas y exceso de grasa mientras oxigena y revitaliza tu rostro.
          <br/><br/>
          <h3 class='text-green-600 font-semibold text-2xl mb-2 text-center'>Beneficios</h3>
          Piel más suave, limpia y luminosa.
          <br/><br/>
          <p class='text-green-700 font-semibold text-center text-xl mt-6'>
            👉 Regálale a tu piel una limpieza profunda y vuelve a sentirla fresca.

          </p>
        `,
        // 🎥 Solo este servicio tiene videos
        video21:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092749/video21_cytvnr.mp4",
        video22:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092743/video22_rzzag4.mp4",
        video23:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092924/video23_zkrekq.mp4"
               
      },
      {
        name: "Plasma nutricional (PRP)",
        description: `
         Tratamiento regenerador que utiliza tu propio plasma para estimular el colágeno, elastina y la renovación celular.
         <br/><br/>
          <h3 class='text-green-600 font-semibold text-2xl mb-2 text-center'>Beneficios</h3>
         Piel firme, luminosa y con aspecto rejuvenecido.
          <br/><br/>
          <p class='text-green-700 font-semibold text-center text-xl mt-6'>
           👉 Activa la belleza natural de tu piel con tu propio poder regenerador.

          </p>
        `,
        // 🎥 Solo este servicio tiene videos
        video31:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092773/video31_ebvqyi.mp4",
        video32:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092779/video32_vlivwg.mp4",
        video33:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092950/video33_pl0ipm.mp4"
               
      },
      {
        name: "Plasma gel",
        description: `
         Biorelleno natural que hidrata, da volumen y mejora la textura de la piel sin sustancias sintéticas.
         <br/><br/>
          <h3 class='text-green-600 font-semibold text-2xl mb-2 text-center'>Beneficios</h3>
          Rostro más terso, contornos definidos y apariencia natural.
          <br/><br/>
          <p class='text-green-700 font-semibold text-center text-xl mt-6'>
           👉 Recupera la firmeza y frescura de tu piel de forma segura y natural.

          </p>
        `,
        // 🎥 Solo este servicio tiene videos
        video43:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092822/video43_osbr5h.mp4",
        video44:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092926/video44_kldmmq.mp4",
        video45:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092801/video45_r6ggh8.mp4"
               
      },
      {
        name: "Cauterización de lunares y verrugas",
        description: `
         Elimina lesiones cutáneas de manera rápida y precisa, con resultados estéticos y sin cicatrices notorias.
          <br/><br/>
          <h3 class='text-green-600 font-semibold text-2xl mb-2 text-center'>Beneficios</h3>
          Piel uniforme, limpia y renovada.
          <br/><br/>
          <p class='text-green-700 font-semibold text-center text-xl mt-6'>
           👉 Despídete de esas imperfecciones y luce una piel más lisa y saludable.

          </p>
        `,
        // 🎥 Solo este servicio tiene videos
        video24:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092759/video24_ccttsk.mp4",
        video25:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092767/video25_ncmbrz.mp4",
        video26:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092752/video26_zrq4fg.mp4"
              
      },
      {
        name: "Ácido hialurónico",
        description: `
        Rellena, hidrata y restaura el volumen facial, devolviéndole vitalidad y juventud a tu rostro.
        <br/><br/>
          <h3 class='text-green-600 font-semibold text-2xl mb-2 text-center'>Beneficios</h3>
          Labios definidos, mejillas firmes y piel más hidratada.
          <br/><br/>
          <p class='text-green-700 font-semibold text-center text-xl mt-6'>
           👉 Rejuvenece tu rostro sin perder tu expresión natural.

          </p>
        `,
        // 🎥 Solo este servicio tiene videos
        video36:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092786/video36_vvdapc.mp4",
        video35:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092795/video35_eimw1v.mp4",
        video34:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092797/video34_mcgrjp.mp4"
              
      },
      {
        name: "Botox",
        description: `
        Suaviza líneas de expresión y previene el envejecimiento facial sin cambiar tus rasgos.
        <br/><br/>
          <h3 class='text-green-600 font-semibold text-2xl mb-2 text-center'>Beneficios</h3>
           Piel más lisa, mirada fresca y aspecto descansado.
          <br/><br/>
          <p class='text-green-700 font-semibold text-center text-xl mt-6'>
           👉 Dale una pausa al tiempo y luce un rostro naturalmente joven. 

          </p>
        `,
        // 🎥 Solo este servicio tiene videos
        image8:"https://res.cloudinary.com/dmgtsa6kx/image/upload/v1763092676/imag8_acykdp.jpg"
        
               
      },
      {
        name: "Hilos Mágicos PDO",
        description: `
         Técnica de lifting sin cirugía que estimula el colágeno y redefine el contorno facial.
          <br/><br/>
          <h3 class='text-green-600 font-semibold text-2xl mb-2 text-center'>Beneficios</h3>
         efecto tensor inmediato y resultados duraderos.
          <br/><br/>
          <p class='text-green-700 font-semibold text-center text-xl mt-6'>
           👉 Eleva, reafirma y rejuvenece tu piel con resultados naturales.

          </p>
        `,
        // 🎥 Solo este servicio tiene videos
        video27:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092777/video27_rzdycu.mp4",
        video28:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092774/video28_tb2alq.mp4",
        video29:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092946/video29_qiwy8z.mp4"
              
      },
      {
        name: "Exosomas",
        description: `
         Innovadora terapia celular que regenera la piel a nivel profundo, mejorando textura y luminosidad.
          <br/><br/>
          <h3 class='text-green-600 font-semibold text-2xl mb-2 text-center'>Beneficios</h3>
             Reparación celular, uniformidad y vitalidad facial
          <br/><br/>
          <p class='text-green-700 font-semibold text-center text-xl mt-6'>
          👉 Descubre el futuro del rejuvenecimiento con exosomas.

          </p>
        `,
        // 🎥 Solo este servicio tiene videos
        video37:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092790/video37_yszmtl.mp4",
        video38:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092792/video38_j9owhe.mp4"
               
      },
      {
        name: "Bíoestimuladores",
        description: `
          Activan la producción de colágeno desde el interior, mejorando la firmeza y elasticidad facial.  
          <br/><br/>
          <h3 class='text-green-600 font-semibold text-2xl mb-2 text-center'>Beneficios</h3>
             Piel más densa, tonificada y rejuvenecida.
          <br/><br/>
          <p class='text-green-700 font-semibold text-center text-xl mt-6'>
          👉 Estimula tu colágeno y logra un rejuvenecimiento progresivo.

          </p>
        `,
        // 🎥 Solo este servicio tiene videos
       image10:"https://res.cloudinary.com/dmgtsa6kx/image/upload/v1763092676/imag10_rmtkzu.jpg"
               
      },
      {
        name: "Lifting facial",
        description: `
         Procedimiento no quirúrgico que reafirma, redefine y eleva los rasgos del rostro.
          <br/><br/>
          <h3 class='text-green-600 font-semibold text-2xl mb-2 text-center'>Beneficios</h3>
         Efecto tensor inmediato y piel más firme.
          <br/><br/>
          <p class='text-green-700 font-semibold text-center text-xl mt-6'>
           👉 Recupera la armonía y juventud de tu rostro sin cirugía.

          </p>
        `,
        // 🎥 Solo este servicio tiene videos
        video46:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092811/video46_lx3alb.mp4",
        video47:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092813/video47_ko9ldy.mp4",
        video48:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092817/video48_l3nepi.mp4"
               
      },
      {
        name: "Lipopapada química",
        description: `
         Disuelve de forma segura la grasa localizada bajo el mentón, afinando el contorno facial.
          <br/><br/>
          <h3 class='text-green-600 font-semibold text-2xl mb-2 text-center'>Beneficios</h3>
          Rostro más definido y perfil estilizado.
          <br/><br/>
          <p class='text-green-700 font-semibold text-center text-xl mt-6'>
           👉 Dile adiós a la papada y resalta tus facciones naturales.

          </p>
        `,
        // 🎥 Solo este servicio tiene videos
        video30:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092776/video30_hid0rr.mp4"     
      },
      {
        name: "Tratamiento integral de manchas, cicatrices y acné",
        description: `
        Protocolos combinados que restauran la piel dañada, unifican el tono y mejoran la textura.
          <br/><br/>
          <h3 class='text-green-600 font-semibold text-2xl mb-2 text-center'>Beneficios</h3>
          Piel más clara, uniforme y suave.
          <br/><br/>
          <p class='text-green-700 font-semibold text-center text-xl mt-6'>
           👉 Recupera la confianza en tu piel con un tratamiento diseñado para ti.

          </p>
        `,
        // 🎥 Solo este servicio tiene videos
        video42:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092931/video42_zcfp3h.mp4",
        video41:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092806/video41_ldztrj.mp4",
        video40:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092920/video40_dhxvgk.mp4"      
      },
      {
        name: "Baby glow",
        description: `
        Terapia que aporta luminosidad y efecto “piel de porcelana” gracias a su acción hidratante y aclarante.
          <br/><br/>
          <h3 class='text-green-600 font-semibold text-2xl mb-2 text-center'>Beneficios</h3>
          Brillo natural, tono uniforme y aspecto saludable.
          <br/><br/>
          <p class='text-green-700 font-semibold text-center text-xl mt-6'>
           👉 Luce una piel radiante, fresca y juvenil con efecto inmediato.

          </p>
        `,
        // 🎥 Solo este servicio tiene videos
        video49:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092829/video49_udaeus.mp4"     
      },
      {
        name: "Hidralips",
        description: `
         Devuélvele la vitalidad a tus labios con nuestro tratamiento Hidralips, que los hidrata profundamente, mejora su color natural y repara la resequedad. Ideal para quienes buscan unos labios saludables, frescos y con un aspecto más voluminoso.
         <br/><br/>
          <h3 class='text-green-600 font-semibold text-2xl mb-2 text-center'>Beneficios</h3>
          Hidratación profunda, suavidad inmediata, reparación de grietas y realce natural del tono.
          <br/><br/>
          <p class='text-green-700 font-semibold text-center text-xl mt-6'>
           👉 ¡Luce unos labios irresistibles!

          </p>
        `,
        // 🎥 Solo este servicio tiene videos
        video39:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092797/video39_xghddk.mp4"      
      },
      {
        name: "Rejuvenecimiento facial",
        description: `
        Combinación de técnicas naturales y médicas para mejorar textura, firmeza y luminosidad. 
          <br/><br/>
          <h3 class='text-green-600 font-semibold text-2xl mb-2 text-center'>Beneficios</h3>
          Piel más joven, vital y equilibrada. 
          <br/><br/>
          <p class='text-green-700 font-semibold text-center text-xl mt-6'>
           👉 Devuélvele frescura y energía a tu rostro de manera natural.

          </p>
        `,
        // 🎥 Solo este servicio tiene videos
        video74:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092889/video74_mjmpzp.mp4",
        image16:"https://res.cloudinary.com/dmgtsa6kx/image/upload/v1763092677/imag16_ux0skd.jpg"     
      },
      {
        name: "Dermaplane facial ",
        description: `
        Exfoliación avanzada mediante una cuchilla especial que elimina células muertas y vello facial, mejorando la absorción de productos.  
          <br/><br/>
          <h3 class='text-green-600 font-semibold text-2xl mb-2 text-center'>Beneficios</h3>
          Piel más suave, lisa y luminosa.
          <br/><br/>
          <p class='text-green-700 font-semibold text-center text-xl mt-6'>
           👉 Dale a tu piel una nueva textura y un brillo espectacular. 

          </p>
        `,
        // 🎥 Solo este servicio tiene videos
        video73:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092907/video73_iopmso.mp4"     
      },
      {
        name: "Micropigmentación",
        description: `
        Define cejas, labios y delineados con resultados naturales y personalizados.
          <br/><br/>
          <h3 class='text-green-600 font-semibold text-2xl mb-2 text-center'>Beneficios</h3>
        Realce facial, simetría y practicidad diaria.
          <br/><br/>
          <p class='text-green-700 font-semibold text-center text-xl mt-6'>
           👉 Resalta tu belleza natural con un diseño que refleja tu estilo.

          </p>
        `,
        // 🎥 Solo este servicio tiene videos
        image6:"https://res.cloudinary.com/dmgtsa6kx/image/upload/v1763092675/imag6_eufsme.jpg",
         image7:"https://res.cloudinary.com/dmgtsa6kx/image/upload/v1763092676/imag7_k9nnkj.jpg"    
      },
    ].map((srv) => ({
      ...srv,
      url: `/servicios/${createSlug(srv.name)}`,
    })),
  },

  // ==========================
  // 💪 ESTÉTICA CORPORAL
  // ==========================
  {
    title: "Estética corporal",
    description:
      "Moldea, tonifica y revitaliza tu cuerpo con técnicas no invasivas.",
    icon: Sparkles,
    buttonText: "Descubrir tratamientos corporales",
    services: [
      {
        name: "Depilación láser IPL",
        description: `
        Elimina el vello no deseado con tecnología de luz pulsada intensa, segura y efectiva.
          <br/><br/>
          <h3 class='text-green-600 font-semibold text-2xl mb-2 text-center'>Beneficios</h3>
         Piel suave, libre de irritación y resultados duraderos.
          <br/><br/>
          <p class='text-green-700 font-semibold text-center text-xl mt-6'>
           👉 Despídete de la depilación tradicional y luce una piel tersa todo el año.

          </p>
        `,
        // 🎥 Solo este servicio tiene videos
        video50:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092830/video50_u69rew.mp4"
           
      },
      {
        name: "Masajes: linfático, relajante y reductor",
        description: `
          Técnicas manuales que estimulan la circulación, liberan tensiones y ayudan a moldear tu figura.
          <br/><br/>
          <h3 class='text-green-600 font-semibold text-2xl mb-2 text-center'>Beneficios</h3>
          Drenaje de líquidos, reducción de medidas y sensación de bienestar profundo.
          <br/><br/>
          <p class='text-green-700 font-semibold text-center text-xl mt-6'>
           👉 Regálate un momento para ti y siente la ligereza en tu cuerpo.

          </p>
        `,
        // 🎥 Solo este servicio tiene videos
        video55:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092859/video55_efydvw.mp4",
        video56:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092841/video56_qhezwn.mp4"
           
      },
      {
        name: "Tratamiento para venas y várices",
        description: `
          Mejora la circulación, reduce inflamaciones y alivia la pesadez en las piernas.
          <br/><br/>
          <h3 class='text-green-600 font-semibold text-2xl mb-2 text-center'>Beneficios</h3>
          Piernas descansadas, piel uniforme y alivio del dolor.
          <br/><br/>
          <p class='text-green-700 font-semibold text-center text-xl mt-6'>
           👉 Devuélvele vitalidad y belleza natural a tus piernas.

          </p>
        `,
        // 🎥 Solo este servicio tiene videos
        video60:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092874/video60_vmr8hm.mp4",
        video61:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092857/video61_vxvvya.mp4",
        video62:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092855/video62_pk3m01.mp4"
           
      },
      {
        name: "Infiltración de quemadores y tonificantes",
        description: `
        Aplicación localizada que ayuda a disolver grasa y reafirmar tejidos de forma efectiva.
          <br/><br/>
          <h3 class='text-green-600 font-semibold text-2xl mb-2 text-center'>Beneficios</h3>
         Reducción de medidas y firmeza visible en zonas específicas.
          <br/><br/>
          <p class='text-green-700 font-semibold text-center text-xl mt-6'>
           👉 Moldea tu figura y potencia tus resultados de manera segura.

          </p>
        `,
        // 🎥 Solo este servicio tiene videos
        image12:"https://res.cloudinary.com/dmgtsa6kx/image/upload/v1763092677/imag12_sczi63.jpg"
           
      },
      {
        name: "Vacumterapia",
        description: `
          Terapia con succión controlada que activa la circulación y combate la celulitis.
          <br/><br/>
          <h3 class='text-green-600 font-semibold text-2xl mb-2 text-center'>Beneficios</h3>
         Piel más firme, lisa y tonificada.
          <br/><br/>
          <p class='text-green-700 font-semibold text-center text-xl mt-6'>
           👉 Dale a tu piel un aspecto uniforme y revitalizado.

          </p>
        `,
        // 🎥 Solo este servicio tiene videos
        video57:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092840/video57_dkdujl.mp4"
           
      },
     {
        name: "Radiofrecuencia",
        description: `
          Estimula la producción de colágeno y elastina mediante ondas de calor controladas.
          <br/><br/>
          <h3 class='text-green-600 font-semibold text-2xl mb-2 text-center'>Beneficios</h3>
          Reafirmación, tonificación y mejora del contorno corporal.
          <br/><br/>
          <p class='text-green-700 font-semibold text-center text-xl mt-6'>
           👉 Reafirma tu piel y disfruta de un cuerpo más firme y definido.

          </p>
        `,
        // 🎥 Solo este servicio tiene videos
        video63:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092852/video63_tirpwa.mp4"
           
      },
      {
        name: "Lipoláser",
        description: `
          Tecnología que elimina grasa localizada mediante luz láser no invasiva.
          <br/><br/>
          <h3 class='text-green-600 font-semibold text-2xl mb-2 text-center'>Beneficios</h3>
         Reducción de medidas y mejora del tono de la piel.
          <br/><br/>
          <p class='text-green-700 font-semibold text-center text-xl mt-6'>
           👉 Reduce, moldea y redefine tu figura sin cirugía.

          </p>
        `,
        // 🎥 Solo este servicio tiene videos
        video51:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092832/video51_zhqxnz.mp4"
           
      },
      {
        name: "Carboxiterapia",
        description: `
          Aplicación de CO₂ medicinal que mejora la oxigenación y rompe depósitos de grasa y celulitis.
          <br/><br/>
          <h3 class='text-green-600 font-semibold text-2xl mb-2 text-center'>Beneficios</h3>
          Piel más tersa, firme y tonificada.
          <br/><br/>
          <p class='text-green-700 font-semibold text-center text-xl mt-6'>
           👉 Activa tu circulación y transforma la textura de tu piel.

          </p>
        `,
        // 🎥 Solo este servicio tiene videos
        video58:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092845/video58_oyjslk.mp4"
           
      },
      {
        name: "Corrientes rusas",
        description: `
          Estimulan los músculos con impulsos eléctricos para tonificar y reafirmar.
          <br/><br/>
          <h3 class='text-green-600 font-semibold text-2xl mb-2 text-center'>Beneficios</h3>
           Fortalecimiento muscular y mejora de la apariencia corporal.
          <br/><br/>
          <p class='text-green-700 font-semibold text-center text-xl mt-6'>
           👉 Tonifica tu cuerpo sin esfuerzo y consigue una figura más firme.

          </p>
        `,
        // 🎥 Solo este servicio tiene videos
        video64:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092866/video64_dfralo.mp4"
           
      },
      {
        name: "Cavitación",
        description: `
         Ultrasonido estético que elimina grasa localizada y mejora el contorno corporal.
          <br/><br/>
          <h3 class='text-green-600 font-semibold text-2xl mb-2 text-center'>Beneficios</h3>
         Reducción visible de medidas y piel más lisa.
          <br/><br/>
          <p class='text-green-700 font-semibold text-center text-xl mt-6'>
           👉 Moldea tu figura con tecnología segura y efectiva.

          </p>
        `,
        // 🎥 Solo este servicio tiene videos
        video52:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092827/video52_h5e9te.mp4"
           
      },
      {
        name: "Hidrolipoclasia",
        description: `
          Técnica no quirúrgica que destruye grasa localizada mediante suero fisiológico y ultrasonido.
          <br/><br/>
          <h3 class='text-green-600 font-semibold text-2xl mb-2 text-center'>Beneficios</h3>
         Reducción de volumen y definición corporal.
          <br/><br/>
          <p class='text-green-700 font-semibold text-center text-xl mt-6'>
           👉 Disuelve la grasa localizada y logra un contorno más armónico.

          </p>
        `,
        // 🎥 Solo este servicio tiene videos
        video59:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092848/video59_br0ht4.mp4"
           
      },
      {
        name: "Criolipólisis",
        description: `
          Congela y elimina células de grasa de forma localizada y segura.
          <h3 class='text-green-600 font-semibold text-2xl mb-2 text-center'>Beneficios</h3>
          Reducción de medidas y resultados progresivos.
          <br/><br/>
          <p class='text-green-700 font-semibold text-center text-xl mt-6'>
           👉 Reduce la grasa localizada con un tratamiento no invasivo y efectivo.

          </p>
        `,
        // 🎥 Solo este servicio tiene videos
        video65:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092864/video65_t8tys5.mp4"
           
      },
      {
        name: "Mantatérmica",
        description: `
        Tratamiento de calor que estimula la sudoración, ayuda a eliminar toxinas y favorece la pérdida de medidas.
          <br/><br/>
          <h3 class='text-green-600 font-semibold text-2xl mb-2 text-center'>Beneficios</h3>
         Desintoxicación, relajación y reafirmación corporal.
          <br/><br/>
          <p class='text-green-700 font-semibold text-center text-xl mt-6'>
           👉 Activa tu metabolismo y renueva tu cuerpo desde adentro.

          </p>
        `,
        // 🎥 Solo este servicio tiene videos
        video54:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092831/video54_da7cdk.mp4",
        video53:"https://res.cloudinary.com/dmgtsa6kx/video/upload/v1763092829/video53_kybvza.mp4"
           
      },
    ].map((srv) => ({
      ...srv,
      url: `/servicios/${createSlug(srv.name)}`,
    })),
  },
];


